import { render, staticRenderFns } from "./teamMembersDisplay.vue?vue&type=template&id=24249f0e&scoped=true&"
import script from "./teamMembersDisplay.vue?vue&type=script&lang=js&"
export * from "./teamMembersDisplay.vue?vue&type=script&lang=js&"
import style0 from "./teamMembersDisplay.vue?vue&type=style&index=0&id=24249f0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24249f0e",
  null
  
)

export default component.exports